var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
export var StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})(function (props) { return (React.createElement(Menu, __assign({ elevation: 0, getContentAnchorEl: null, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    } }, props))); });
export var StyledMenuItem = withStyles(function () { return ({
    root: {},
}); })(MenuItem);
//# sourceMappingURL=appsMenuStyle.js.map